import { updateCustomerLabels as updateCheckoutCustomerLabels } from '../checkout/checkout.store';
import bus from '../connection/storeManagerConnection';
import {
    closeSession,
    fetchCartsLocations,
    fetchSessions,
    setDevicesLoading,
    updateCartLocation,
    updateCustomerLabels,
    updateDevice,
    updateDeviceLocations,
    updateTicket,
    updateWeights,
} from './sessionMonitor.store';
import {
    addTaraChange,
    addTicketChange,
    sessionManualCheck,
    sessionScaleTrigger,
    sessionWeightDeviation,
    sessionWeightWithoutScan,
} from './sessionMonitorDetails.store';
import { CustomerPropertiesChangedNotification } from '@whiz-cart/node-shared/models/customer/customerPropertiesChangedNotification';
import { CustomerTicket } from '@whiz-cart/node-shared/models/ticket/ticket';

export default () => [
    bus.onConnection(() => {
        if (!bus.config.storeGuid) return [];
        void fetchCartsLocations(bus.config.storeGuid);
        void fetchSessions(bus.config.storeGuid);
    }, setDevicesLoading),

    bus.subscribe('storeSessionStart', (msg) => {
        // TODO: parse msg
        updateDevice(msg as any);
    }),

    bus.subscribe('storeSessionTransferCompleted', (msg) => {
        // TODO: parse msg
        updateDevice(msg as any);
    }),

    bus.subscribe('storeSessionEnd', (msg) => {
        // TODO: parse msg
        closeSession(msg as any);
    }),

    bus.subscribe('deviceLocationUpdated', (msg) => {
        // TODO: parse msg
        updateDeviceLocations([msg]);
    }),

    bus.subscribe('deviceLocationBatchUpdate', (msg) => {
        // TODO: parse msg
        updateDeviceLocations(msg);
    }),

    bus.subscribe('ticketCreated', CustomerTicket, (msg) => {
        updateTicket(msg);
        addTicketChange(msg);
    }),

    bus.subscribe('ticketChanged', CustomerTicket, (msg) => {
        updateTicket(msg);
        addTicketChange(msg);
    }),

    bus.subscribe('sessionMonitor_admin', CustomerTicket, (msg) => {
        updateTicket(msg);
        addTicketChange(msg);
    }),

    bus.subscribe('storeSessionTara', (item: any) => {
        // TODO: parse item
        updateWeights({ ...item, ...item.tara, t: item.createdOn });
        addTaraChange(item);
    }),

    bus.subscribe('sessionScaleTrigger', (item: any) => {
        // TODO: parse item
        updateWeights({ ...item, t: item.createdOn });
        sessionScaleTrigger(item);
    }),

    bus.subscribe('sessionWeightWithoutScan', (item: any) => {
        // TODO: parse item
        updateWeights({ ...item, t: item?.model?.createdOn });
        sessionWeightWithoutScan(item);
    }),

    bus.subscribe('sessionWeightDeviation', (item: any) => {
        // TODO: parse item
        updateWeights({ ...item, t: item.createdOn });
        sessionWeightDeviation(item);
    }),

    bus.subscribe('sessionManualCheck', (item) => {
        // TODO: parse item
        sessionManualCheck(item);
    }),

    bus.subscribe('deviceExpectedWeightUpdated', (item: any) => {
        // TODO: parse item
        updateWeights({
            sessionGuid: item.sessionGuid,
            t: item.weight?.ts,
            expectedWeight: item.weight?.weight,
        });
    }),

    bus.subscribe('deviceActualWeightUpdated', (item: any) => {
        // TODO: parse item
        updateWeights({
            sessionGuid: item.sessionGuid,
            t: item.weight?.ts,
            actualWeight: item.weight?.weight,
        });
    }),

    bus.subscribe('customerPropertiesChanged', CustomerPropertiesChangedNotification, (msg) => {
        updateCustomerLabels(msg.customerGuid, msg.properties.labels ?? []);
        updateCheckoutCustomerLabels(msg.customerGuid, msg.properties.labels ?? []);
    }),

    bus.subscribe('cartLocationUpdated', (msg: any) => {
        updateCartLocation(msg);
    }),
];
